import Interweave from 'interweave'
import { isEmpty } from 'lodash-es'
import PropTypes from 'prop-types'
import { convertMdToHtml } from '..'
import Section from '../../Section'

export const buildRepoScopeContent = repoFiles =>
  repoFiles
    .map(repo => {
      let repoContent = `<p>Repo: <code>${repo.name}</code></p>`
      if (repo.includePaths?.length && repo.hideIncluded !== true) {
        repoContent = `${repoContent}<p>Included Paths: ${repo.includePaths
          .map(path => `<code>${path}</code>`)
          .join(', ')}</p>`
      }
      if (repo.excludePaths?.length && repo.showExcluded) {
        repoContent = `${repoContent}<p>Excluded Paths: ${repo.excludePaths
          .map(path => `<code>${path}</code>`)
          .join(', ')}</p>`
      }
      if (repo.extensions?.length) {
        repoContent = `${repoContent}<p>Extensions: ${repo.extensions
          .map(ext => `<code>${ext}</code>`)
          .join(', ')}</p>`
      }
      return repoContent
    })
    .join('<br>')

const Scope = ({ report: { reportContent } }) => {
  const includeContent = buildRepoScopeContent(reportContent.repoFiles)

  return (
    <Section title="Scope">
      {!isEmpty(reportContent.summary.scope?.description) ? (
        <Interweave content={convertMdToHtml.makeHtml(reportContent.summary.scope?.description)} />
      ) : null}
      {!isEmpty(reportContent.summary.scope?.filesIncluded) || !isEmpty(includeContent) ? (
        <div>
          <h4>Files Included</h4>
          <Interweave
            content={convertMdToHtml.makeHtml(reportContent.summary.scope?.filesIncluded)}
          />
          {includeContent?.length ? (
            <div className="scope-files-list">
              <Interweave content={convertMdToHtml.makeHtml(includeContent)} />
            </div>
          ) : null}
        </div>
      ) : null}
      {!isEmpty(reportContent.summary.scope?.filesExcluded) ? (
        <div>
          <h4>Files Excluded</h4>

          <Interweave
            content={convertMdToHtml.makeHtml(reportContent.summary.scope?.filesExcluded)}
          />
        </div>
      ) : null}
    </Section>
  )
}

Scope.propTypes = {
  report: PropTypes.object,
}

export default Scope
